import React, { MouseEventHandler, ReactNode, useState } from 'react'
import {
  Dialog as MuiDialog,
  DialogContent,
  styled,
  IconButton,
  DialogProps as MuiDialogProps,
  SxProps,
} from '@mui/material'

import { ReactComponent as CloseSvg } from '@/assets/imgs/close.svg'

const CloseButton = styled(IconButton)`
  position: absolute;
  padding: 0;
  z-index: 2;
  background-color: #121212;
`

interface DialogProps {
  open?: boolean
  onClose?: (ev?: any, reason?: 'backdropClick' | 'escapeKeyDown') => void
  children?: ReactNode
  TransitionProps?: MuiDialogProps['TransitionProps']
  showCloseButton?: boolean
  sx?: SxProps
}

const Dialog = ({ sx, open, onClose, children, TransitionProps, showCloseButton = true }: DialogProps) => {
  return (
    <MuiDialog
      sx={sx}
      open={open}
      onClose={onClose}
      TransitionProps={TransitionProps}
      PaperProps={{
        sx: {
          backgroundColor: '#111303',
          margin: 20,
          backgroundImage: 'unset',
          border: '1px solid rgba(191, 255, 11, 0.2)',
        },
      }}
    >
      {showCloseButton && (
        <CloseButton
          onClick={onClose}
          sx={{
            right: 20,
            top: {
              xs: 8,
              md: 20,
            },
          }}
        >
          <CloseSvg />
        </CloseButton>
      )}

      <DialogContent
        sx={{
          p: { xs: '40px 20px', md: '40px 40px' },
        }}
      >
        {children}
      </DialogContent>
    </MuiDialog>
  )
}

export default Dialog
